var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('navbar'),_c('sidebar'),_c('div',{staticClass:"content-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2),_c('footer',{staticClass:"footer footer-alt footer-main"},[_vm._v(" 2021 © Aguda ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }